import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PriceModel } from './Price.model';
export class LineItemModel {
  constructor(lineItemModel) {
    _defineProperty(this, "id", void 0);
    _defineProperty(this, "membersOnly", void 0);
    _defineProperty(this, "policies", void 0);
    _defineProperty(this, "catalogReference", void 0);
    _defineProperty(this, "physicalProperties", void 0);
    _defineProperty(this, "priceBeforeDiscounts", void 0);
    _defineProperty(this, "price", void 0);
    _defineProperty(this, "lineItemPrice", void 0);
    _defineProperty(this, "quantity", void 0);
    _defineProperty(this, "productName", void 0);
    _defineProperty(this, "descriptionLines", void 0);
    this.id = lineItemModel.id;
    this.membersOnly = lineItemModel.membersOnly;
    this.policies = lineItemModel.policies;
    this.catalogReference = lineItemModel.catalogReference;
    this.physicalProperties = lineItemModel.physicalProperties;
    this.priceBeforeDiscounts = lineItemModel.priceBeforeDiscounts;
    this.price = lineItemModel.price;
    this.lineItemPrice = lineItemModel.lineItemPrice;
    this.quantity = lineItemModel.quantity;
    this.productName = lineItemModel.productName;
    this.descriptionLines = lineItemModel.descriptionLines;
  }
  static fromV1(sdkLineItem, modelContext) {
    return new LineItemModel({
      id: sdkLineItem._id,
      membersOnly: Boolean(sdkLineItem.membersOnly),
      policies: sdkLineItem.policies,
      catalogReference: sdkLineItem.catalogReference,
      physicalProperties: sdkLineItem.physicalProperties,
      priceBeforeDiscounts: PriceModel.fromV1(sdkLineItem.priceBeforeDiscounts, modelContext),
      price: PriceModel.fromV1(sdkLineItem.price, modelContext),
      lineItemPrice: PriceModel.fromV1(sdkLineItem.lineItemPrice, modelContext),
      quantity: sdkLineItem.quantity,
      productName: sdkLineItem.productName,
      descriptionLines: sdkLineItem.descriptionLines
    });
  }
}
//# sourceMappingURL=LineItem.model.js.map